// extracted by mini-css-extract-plugin
export var addButton = "_nn-0";
export var border = "_nn-8";
export var check = "_nn-h";
export var danger = "_nn-6";
export var dropdownContainer = "_nn-1";
export var editModalBody = "_nn-j";
export var footerContainer = "_nn-i";
export var fullWidth = "_nn-a";
export var hide = "_nn-9";
export var icon = "_nn-3";
export var input = "_nn-7";
export var inputFlex = "_nn-b";
export var inputWrapper = "_nn-c";
export var manualFocus = "_nn-5";
export var optionButton = "_nn-4";
export var pillWrapper = "_nn-e";
export var pointer = "_nn-2";
export var showOverflow = "_nn-f";
export var tagsFlex = "_nn-d";
export var xButton = "_nn-g";